enum IDMVersion {
    v1,
    v2,
}

export default IDMVersion;
